import { CONSTANTS } from '../Helpers/Configuration';
import { formatPhoneNumber } from '../Helpers/PhoneHelper';
import get from 'lodash/get';
import set from 'lodash/set';
import findIndex from 'lodash/findIndex';
import findLast from 'lodash/findLast';
import isEqual from 'lodash/isEqual';
import forEach from 'lodash/forEach';
const { controlTypes, applicationFormStatuses } = CONSTANTS;

export const navigateQuestions = (template, handler) => {
    template.pages && template.pages.forEach((p, pIndex) => {
        p.sections && p.sections.forEach((s, sIndex) => {
            s.groups && s.groups.forEach((g, gIndex) => {
                g.questions && g.questions.forEach((q, qIndex) => {
                    handler(p, s, g, q, pIndex, sIndex, gIndex, qIndex);
                });
            });
        });
    });
};

export const getFilterSearchFieldsFormValues = (template, applicationValues = {}) => {
    if (!template || !applicationValues) {
        return;
    }
    let filterSearchFields = [];
    navigateQuestions(template, (p, s, g, q, pIndex, sIndex, gIndex, qIndex) => {
        if (q && q?.type === controlTypes.filteredsearch && q?.filteredSearch?.model) {
            let recordIds = [];
            if (s.showRepetition) {
                const fieldFormName = `${p.id}.${s.id}`;
                const repetitionSectionFormValues = get(applicationValues, fieldFormName, null);
                repetitionSectionFormValues && repetitionSectionFormValues?.map((questionValue) => {
                    const fieldFormValue = get(questionValue, q.id, null);
                    if (fieldFormValue) {
                        recordIds.push(fieldFormValue);
                    }
                });
            } else {
                const fieldFormName = `${p.id}.${q.id}`;
                const fieldFormValue = get(applicationValues, fieldFormName, null);
                if (fieldFormValue) {
                    recordIds.push(fieldFormValue);
                }
            }
            recordIds = recordIds.filter((id) => !!id);
            if (recordIds && recordIds?.length > 0) {
                filterSearchFields.push({
                    question: q,
                    value: recordIds,
                    pIndex,
                    sIndex,
                    gIndex,
                    qIndex,
                });
            }
        }
    });
    return filterSearchFields;
};

export const cleanseLists = (template, application) => {
    if (!template || !application || !application.values || application.status === applicationFormStatuses.SUBMITTED) {
        return;
    }
    navigateQuestions(template, (p, s, g, q) => {
        if ((q.type === controlTypes.singlechoice || q.type === controlTypes.checkbox) && q.possibleValues.values?.length > 0) {
            const allValues = q.possibleValues.values.map(x => x.value);
            if (s.showRepetition) {
                const repetitionSectionValues = get(application.values, `${p.id}.${s.id}`, []);
                repetitionSectionValues.forEach((rep, i) => {
                    const val = get(rep, q.id, null);
                    const codePath = `${p.id}.${s.id}.${i}.${q.id}`;
                    if (val) {
                        if (!Array.isArray(val) && !allValues.includes(val)) {
                            set(rep, q.id, undefined);
                            set(application.codes, codePath, undefined);
                        }
                        else if (Array.isArray(val) && val.length > 0) {
                            const codes = get(application.codes, codePath, undefined);
                            const codesToRemove = [];
                            const newVal = val.filter((x, j) => {
                                const included = allValues.includes(x);

                                if (!included && codes?.length > j) {
                                    codesToRemove.push(codes[j]);
                                }

                                return included;
                            });

                            set(rep, q.id, newVal);

                            if (codesToRemove.length) {
                                const newCodes = codes.filter(c => !codesToRemove.includes(c));
                                set(application.codes, codePath, newCodes);
                            }
                        }
                    }
                });
            }
            else {
                const val = get(application.values, `${p.id}.${q.id}`, null);
                const path = `${p.id}.${q.id}`;
                if (val) {
                    if (!Array.isArray(val) && !allValues.includes(val)) {
                        set(application.values, path, undefined);
                        set(application.codes, path, undefined);
                    }
                    else if (Array.isArray(val) && val.length > 0) {
                        const codes = get(application.codes, path, undefined);
                        const codesToRemove = [];
                        const newVal = val.filter((x, i) => {
                            const included = allValues.includes(x);

                            if (!included && codes?.length > i) {
                                codesToRemove.push(codes[i]);
                            }

                            return included;
                        });

                        set(application.values, path, newVal);

                        if (codesToRemove.length) {
                            const newCodes = codes?.filter(c => !codesToRemove.includes(c));
                            set(application.codes, path, newCodes);
                        }
                    }
                }
            }
        }
    });
};

export const findNextAvailablePageId = (pageId, allPages, hiddenPageIds) => {
    let targetPageId = null;
    if (pageId) {
        const pageIndex = findIndex(allPages, { id: pageId });
        const targetPage = allPages?.find((p, i) => {
            return i > pageIndex && !hiddenPageIds.includes(p.id);
        });
        targetPageId = targetPage?.id;
    }
    return targetPageId;
};

export const findPreviousAvailablePageId = (pageId, allPages, hiddenPageIds) => {
    let targetPageId = null;
    let pageIndex;
    if (pageId) {
        pageIndex = findIndex(allPages, { id: pageId });
    } else {
        pageIndex = allPages.length;
    }
    const targetPage = findLast(allPages, (p, i) => {
        return i < pageIndex && !hiddenPageIds.includes(p.id);
    });
    targetPageId = targetPage?.id;
    return targetPageId;
};

const blank = '';

const formatChangedValue = (question, value, template, locale) => {
    //Empty string, null, undefined, empty array are all formatted to '' for dialog showing changed values as friendly strings
    //Not using !value in case we get values of "0" or "false"
    if (value === blank || value === null || value === undefined || (Array.isArray(value) && !value?.length)) {
        return blank;
    }

    switch (question.type) {
        case CONSTANTS.controlTypes.datepicker:
            return value ? new Date(value).toLocaleDateString() : blank;

        case CONSTANTS.controlTypes.daterange:
            if (typeof (value) === 'string' && value.includes(',')) {
                const dates = value.split(',');
                if (dates?.length === 2) {
                    return new Date(dates[0]).toLocaleDateString() + ' - ' + new Date(dates[1]).toLocaleDateString();
                }
            }
            break;

        case CONSTANTS.controlTypes.checkbox:
        case CONSTANTS.controlTypes.radiogroup:
        case CONSTANTS.controlTypes.singlechoice:
            // eslint-disable-next-line no-case-declarations
            let vals = [];
            Array.isArray(value) ? vals = value : vals.push(value.toString());

            //Find labels by locale stored within the template for each value we have
            locale = locale || 'en-US';
            if (vals.length && template?.templateMessages?.languages[locale]) {
                return vals.map(val => {
                    var labelObj = question?.possibleValues?.values?.find(v => v.value === val);
                    //the labelObj can sometimes have a .label or .labelId prop. Account for both. 
                    return labelObj && labelObj.label ? labelObj.label : 
                        labelObj && template?.templateMessages?.languages[locale]?.messages[labelObj?.labelId] || val;
                }).join('\n');
            }
            break;

        case CONSTANTS.controlTypes.phone:
            return formatPhoneNumber(value);
    }

    //Force any other case to a string
    return typeof (value) === 'object' ? JSON.stringify(value) : value.toString();
};

const isEmptyValue = (value) =>
    value === '' || value === null || value === undefined;

const compareValues = (oldV, newV, q, template, locale) => {
    const oldVal = isEmptyValue(oldV) ? blank : oldV;
    const newVal = isEmptyValue(newV) ? blank : newV;

    if (
        // If data types are different, consider it changed
        typeof oldVal !== typeof newVal ||
        // If data types are not object, do a simple comparison
        (typeof oldVal !== 'object' && oldVal !== newVal) ||
        // If one is empty but the other isn't
        (isEmptyValue(oldVal) !== isEmptyValue(newVal)) ||
        // If data type is object, do a lodash object comparison
        typeof oldVal === 'object' && !isEqual(oldVal, newVal)
    ) {
        const formattedNew = formatChangedValue(q, newVal, template, locale);
        const formattedOld = formatChangedValue(q, oldV, template, locale);

        if (formattedNew === formattedOld || q.type === CONSTANTS.controlTypes.phone && formattedNew.replace(/\D/g, '') === formattedOld.replace(/\D/g, '')) {
            //Values of different types will always be treated as different. But that difference could be a phone number being converted from string to phone object.
            //Comparing the raw numbers lets us compare just the numbers of a phone
            return null;
        }

        return {
            key: q.id,
            value: formattedNew,
            oldValue: formattedOld,
            label: q.labelId
        };
    }

    return null;
};

export const findChangedValues = (originalValues, values, template, locale) => {
    const changedValues = [];
    if (originalValues && values && template) {
        navigateQuestions(template, (p, s, _, q) => {
            if (!s.showRepetition) {
                const oldVal = originalValues?.[p.id]?.[q.id];
                const newVal = values?.[p.id]?.[q.id];
                const difference = compareValues(oldVal, newVal, q, template, locale);

                if (difference) {
                    changedValues.push(difference);
                }
            }
            else {
                const oldSecValues = originalValues?.[p.id]?.[s.id] || [];
                const newSecValues = values?.[p.id]?.[s.id] || [];
                let largerLength = oldSecValues.length < newSecValues.length ?
                    newSecValues.length : oldSecValues.length;

                for (let i = 0; i < largerLength; i++) {
                    const oldVal = oldSecValues?.[i]?.[q.id];
                    const newVal = newSecValues?.[i]?.[q.id];
                    const difference = compareValues(oldVal, newVal, q, template, locale);

                    if (difference) {
                        changedValues.push(difference);
                    }
                }
            }
        });
    }
    return changedValues;
};

export const getEmailPersonalizationQuestions = (template, personalizationFields) => {
 
    let fields = [];
    forEach(template.pages, page => {
        forEach(page.sections, section => {
            if (section.showRepetition === undefined || section.showRepetition == false) {
                forEach(section.groups, group => {
                    forEach(group.questions, question => {
                        if ((question.type === 'text' || question.type === 'phone') && personalizationFields.find(x => x.destinationAttributePath === question.eedmDestinationAttribute && x.model === question.eedmDestinationModel)) {
                            fields.push({
                                questionId: question.id,
                                dataId: personalizationFields.find(x => x.destinationAttributePath === question.eedmDestinationAttribute && x.model === question.eedmDestinationModel).id
                            });
                        }
                    });
                });
            }
        });
    });

    return fields;
};

export const getApplicationValue = (obj, searchKey, dataId, result = []) => {
    const keyValue = result;
    Object.keys(obj).forEach(key => {
        const value = obj[key];
        if (key === searchKey && typeof value !== 'object') {                
            if (value) {
                keyValue.push(value);
            }
        }
        else if (key === searchKey && dataId === 'phone-number') {
            if (value?.code && value?.number) {
                keyValue.push(`+${value.code}${value.number}`);
            }
            else if (value?.number) {
                keyValue.push(value.number);
            }
        }
        else if (value && typeof value === 'object') {
            getApplicationValue(value, searchKey, dataId, keyValue);
        }
    });
    return keyValue;
};


export const findChangedStagerValues = (originalValues, values) => {
    const changedValues = [];
    if (originalValues?.length && values?.length) {
        originalValues.forEach((v, i) => {
            if (!isEqual(v.propertyValues, values[i].propertyValues)) {
                const value = {
                    oldValue: v.propertyValues,
                    newValue: values[i].propertyValues,
                    propertyName: v.propertyName
                };
                changedValues.push(value);
            }
        });
    }    
    return changedValues;
};

export const isApplicationSubmitted = (app) => {
    if(app?.status === applicationFormStatuses.STARTED) {
        //Lock down an app if it has a payment pending
        return app?.paymentInformation?.paymentStatus && !([CONSTANTS.applicationPaymentInformation.paymentStatus.draft, CONSTANTS.applicationPaymentInformation.paymentStatus.successful].includes(app?.paymentInformation?.paymentStatus));
    }
    return !CONSTANTS.preSubmittedStatuses.includes(app?.status);
};